
import { AxiosResponse } from 'axios';
import { Component, Vue } from 'vue-property-decorator';

const _ = {
  keyBy: require('lodash/keyBy'),
  each: require('lodash/forEach'),
  map: require('lodash/map')
};

// interface 接口定义 用来检测数据类型
interface Form {
  name: string;
  city: string;
  list_img_url: string;
  unit_img_url: [];
}

// 必填项
interface Validator {
  field: string;
  validate: (value: any, avtivity: Form) => boolean;
  message: string;
  status: 'success' | 'error';
  help: string;
}
const { VUE_APP_LIMIT: LimitApi } = process.env;
const API = {
  product: `${LimitApi}/boss/setting/auth/user`,
  clerk_list: `${LimitApi}/boss/setting/staff`,
  add_user: `${LimitApi}/boss/setting/auth/user`,
  del_user: `${LimitApi}/boss/setting/auth/user`
};
const columns = [
  { title: 'ID', dataIndex: 'number', key: 'number' },
  { title: '姓名', dataIndex: 'name', key: 'name' },
  { title: '手机号', dataIndex: 'mobile', key: 'mobile' },
  { title: '操作', key: 'operation', scopedSlots: { customRender: 'operation' } }
];

// 必填项提示信息列表
function getValidatorMap(): { [field: string]: Validator } {
  const list: any[] = [
    {
      field: 'uid',
      validate: (value: string): boolean => !!value,
      message: '请输入名称'
    }
  ].map((item): Validator => ({ ...item, status: 'success', help: '' }));
  return _.keyBy(list, (item: Validator) => item.field);
}

@Component
export default class MangementAccount extends Vue {
  table_data: any = {};
  modal_is_show = false;
  clerk_list_all: any = [];
  fetching = false;
  form: any = {};
  timeout: any = null;
  validatorMap: { [field: string]: Validator } = getValidatorMap();
  confirmLoading = false;
  del_modal_is_show = false;
  del_item: any = {};
  seach_val = '';
  seach_model_data = '';

  handleEmptyVal() {
    this.seach_val = '';
    this.seach_model_data = '';
    this.init(1, this.seach_val);
  }

  handleSeach() {
    this.seach_val = this.seach_model_data;
    this.init(1, this.seach_val);
  }

  async handleAuthDel(item: any) {
    const { data } = await this.$axios.delete(`${API.del_user}/${this.del_item.id}`);
    if (data.status === 200) {
      this.$message.success('删除成功');
      this.init(this.table_data.current, this.seach_val);
    } else {
      this.$message.error(data.message);
    }
    this.del_modal_is_show = false;
    console.log(this.del_item);
  }

  handleAuthEdit(item: any) {
    console.log(item);
    this.$router.push({
      path: '/limit/edit-account',
      query: {
        product_id: this.$route.query.id,
        id: item.id,
        name: item.name,
        title_name: this.$route.query.name
      }
    });
  }

  validateCommit() {
    const form = this.form as any;
    let is_valid = true;
    _.each(this.validatorMap, (validator: Validator, field: string) => {
      if (!this.validate(field)) {
        is_valid = false;
      }
    });
    if (!is_valid) {
      this.$message.error('请填入必填项');
    }
    return is_valid;
  }

  validate(field: string) {
    const form = this.form as any;
    const is_valid = this.validatorMap[field].validate(form[field], form);
    this.validatorMap[field].status = is_valid ? 'success' : 'error';
    this.validatorMap[field].help = is_valid ? '' : this.validatorMap[field].message;
    return is_valid;
  }

  handChangePaging(pagination: any, table_filters: any, sorter: any) {
    this.init(pagination.current, this.seach_val);
  }

  paginationOption(data: RemotePagination<any>) {
    return {
      total: data.total || 0,
      showTotal: (total: number) => `共${data.total}条，每页${data.limit}条`,
      pageSize: data.limit || 1,
      current: data.current || 1
    };
  }

  async handleModelSubmit() {
    if (!this.validateCommit()) {
      return;
    }
    const { data } = await this.$axios.post(API.add_user, {
      product_id: this.$route.query.id,
      uid: this.form.uid
    });
    if (data.status === 200) {
      this.$message.success('添加成功');
      this.init(this.table_data.current, this.seach_val);
    } else {
      this.$message.error('新增账号失败');
    }
    this.modal_is_show = false;
  }

  handleAddAccountModel() {
    this.modal_is_show = true;
    this.form = {};
  }

  searchReferrer(value: any) {
    if (!value) {
      this.clerk_list_all = [];
      return;
    }
    this.fetching = true;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.getClerkListAll(value);
    }, 1000);
  }

  getClerkListAll(name: any) {
    return this.$axios.get(`${API.clerk_list}?name=${name}`).then((res: AxiosResponse) => {
      const remote = res.data;
      console.log(remote);
      if (remote.status !== 200) {
        this.$message.error(remote.message);
        return;
      }
      this.clerk_list_all = remote.data;
      if (this.clerk_list_all.length === 0) {
        this.fetching = false;
      }
    });
  }

  async init(page: number, name: string) {
    const { data } = await this.$axios.get(`${API.product}?product_id=${this.$route.query.id}&name=${name}&current=${page}&limit=20`);
    if (data.status !== 200) {
      this.$message.error(data.message);
      return;
    }
    this.table_data = data.data ? data.data : [];
  }

  created() {
    this.init(1, '');
  }

  get columns() {
    return columns;
  }
}
